export default {
  notfound: {
    title: 'Kjo faqe nuk është krijuar ende',
    hint: 'Më tregoni më shumë për këtë faqe që të mund ta krijoj',
  },
};